import { useTranslation } from 'react-i18next';
import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import apiRequest from '../../functions/api';
import { TableCell,TableRow,TableBody, TableHead,Table,Paper,TableContainer, TextField, Typography,MenuItem,Button} from "@mui/material";
import { withStyles } from '@mui/styles';
import Grid from '@mui/material/Grid'
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import {pad} from "../../functions/default";
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import Page from "../shared/components/PageComponent";
import openFile from "../shared/functions/download";
//import DesktopDatePicker from '@mui/lab/DesktopDatePicker';
const styles = (theme) => ({
  root: {
    marginLeft: theme.spacing(9),
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    [theme.breakpoints.down("sm")]: {
      marginLeft: 0,
    },
  },
  paper: {
    margin: theme.spacing(2),
  },
  form: {
    margin: theme.spacing(1),
    flex: 1
  },
  anwesend: {
    color: theme.palette.background.main,
    backgroundColor: theme.palette.success.main,
  },
  abwesend: {
    color: theme.palette.background.main,
    backgroundColor: theme.palette.error.main,
  }
});
function ErgebnisRechnung(props) {
  const { t } = useTranslation();
  const {accessToken, client} = props;
  const [isLoading, setIsLoading] = useState(false);//True=ladescreen
  const [datum, ] = useState(new Date().getFullYear().toString()+'-'+pad(new Date().getMonth()+1,2)+'-'+pad(new Date().getDate(),2));
  const navigate = useNavigate();
  const {showSuccessMessage, showErrorMessage} = useMessage();
  const [monate, setMonate] = useState([]);//Array mit ordnern
  const [filter, setFilter] = useState("");
  useEffect(() => {
    setIsLoading(true);
    load("");
    // eslint-disable-next-line
  }, []);
function drucken(value,wahl,name){
  setIsLoading(true)
  const headers={
    "Authorization": "Bearer "+accessToken,
  }
  const payload = {
    "mandant": client,
    "program": "FWEBEG",
    "wahl":wahl,
    "value":value,
    "statement": "KALKULATION",
    "date": datum,
  }
  axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
  .then((response) => {
    console.log(response);
    var fileName = name;
    var contentFile = response.data;
    const mimeType = response.headers['content-type'] || 'application/pdf'
    openFile(fileName, contentFile, mimeType);
    setIsLoading(false)
  })
  .catch(function (error) {
    setIsLoading(false)
    console.log(error);
    showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
  });
}
  const load = (wahl) => {
    console.log(wahl)
    setIsLoading(true)
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "FWEBEG",
      "wahl":wahl,
      "statement": "KALKULATION",
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, laden, setRedirect);
  }
  const setRedirect = (path) => {
    navigate(path);
  }
  
  const laden = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      showSuccessMessage(t("OK"))
      console.log(response.data.merke)
      setMonate(response.data.monate)
      console.log(response.data.monate)
    } else {
      if (response) {
      } else {
      }
    }
  }
  const auswahl = (wahl) => {
    console.log(wahl)
    setIsLoading(true)
    const headers={
      "Authorization": "Bearer "+accessToken,
    }
    const payload = {
      "mandant": client,
      "program": "FWEBEG",
      "wahl":wahl,
      "statement": "KALKULATION",
      "date": datum,
    }
    apiRequest('POST', 'daten', payload, headers, auswahlLaden, setRedirect);
  }
  
  const auswahlLaden = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.monate===undefined){
        showErrorMessage(t("Nichts gefunden"))
        setMonate(response.data.monate)
        return
      }
      console.log(response.data.merke)
      setMonate(response.data.monate)
      console.log(response.data.monate)
    } else {
      if (response) {
      } else {
      }
    }
  }
  const showMonate =(monate!==undefined) ? monate.filter(
      (obj) => obj.bez.toUpperCase().includes(filter.toUpperCase())
    ).map((dataObject, count) => {
    return(
      <TableRow>
      <TableCell component="th" scope="row" item xs={2} color="textSecondary">
        <Typography>{dataObject.bez}</Typography>
      </TableCell>
      <TableCell component="th" scope="row" item xs={2} color="textSecondary">
      <Button  style={{textTransform:"none"}}
       key={dataObject.key}
       variant=""
       component="span" color="primary"
       value={dataObject.key}
       onClick={(event)=>drucken(dataObject.key,"GM",dataObject.bez)} >
         {t("Ansehen")}
      </Button>
      </TableCell>
      </TableRow>
        );
  })
  :
  <MenuItem >
      {t("Keine Upload Register gefunden")}
  </MenuItem>
  
  ;
  
  if (isLoading) {
    return <LoadingComponent />
  }
  return (
    <Page>
      {monate?
      <Grid container spacing={1} justifyContent={"center"}>
        <Grid item xs={12} >
          <Typography variant="h4">{t("Monat wählen")}</Typography>
        </Grid>
       {/*} <Grid item xs={12}>
          {showMonate}
      </Grid> */}
      <Grid item xs={"10"}>
        <TableContainer component={Paper}>
        <Table>
          <TableHead>
          <TableRow>
              <TableCell>
              <TextField  color="primary" 
                  label={t("Suchen")}
                  onChange={(event) =>setFilter(event.target.value)}
                />
              </TableCell>
              <TableCell>
                <Typography></Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {showMonate}
        </TableBody>
        </Table>
        </TableContainer>
        </Grid>   
      </Grid>
      :
      <Grid container spacing={1} justifyContent={"center"}>
        <Grid item xs={12} >
          <Typography variant="h4">{t("Art der Ergebnisrechnung")+" ?"}</Typography>
        </Grid>
        <Grid item xs={5}>
          <Button
            fullWidth
            variant="contained"
            component="span"
            color="primary"
            label={t("Gesamt")}
            onClick={(e)=>auswahl("G")}
          >
            {t("Gesamt")}
          </Button>
        </Grid>
        <Grid item xs={5}>
          <Button
            fullWidth
            variant="contained"
            component="span"
            color="primary"
            label={t("Nach Kostenstelle")}
            onClick={(e)=>auswahl("K")}
          >
            {t("Nach Kostenstelle")}
          </Button>
        </Grid>
      </Grid>
      }
    </Page>
    );
}
export default withStyles(styles)(ErgebnisRechnung);
